import React from "react";

/**
 * Tiny inline sparkline. Data: [{month, count}, ...]
 * Draws as SVG path in gold, no external libs.
 */
export default function Sparkline({ data = [], width = 90, height = 28, color = "#C9943D", strokeWidth = 1.6 }) {
  if (!data || data.length === 0) return <div style={{ width, height }} className="opacity-40" />;
  const counts = data.map((d) => Number(d.count) || 0);
  const max = Math.max(1, ...counts);
  const min = 0;
  const stepX = data.length > 1 ? width / (data.length - 1) : 0;
  const points = counts.map((c, i) => {
    const x = i * stepX;
    const y = height - ((c - min) / (max - min || 1)) * (height - 4) - 2;
    return `${x.toFixed(2)},${y.toFixed(2)}`;
  });
  const path = "M" + points.join(" L");
  const last = counts[counts.length - 1];
  const lastX = (data.length - 1) * stepX;
  const lastY = height - ((last - min) / (max - min || 1)) * (height - 4) - 2;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden>
      <path d={path} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lastX} cy={lastY} r="2.4" fill={color} />
    </svg>
  );
}
